import { useEffect, useState } from 'react';
import axios from 'axios';
import Api_key from './apiconfiguration';

const cache = new Map();
export default function TitleLogo({ id, mediaType = 'movie', title, enabled = true }) {
  const key = `${mediaType}/${id}`;
  const [logo, setLogo] = useState(() => cache.get(key));
  const [failed, setFailed] = useState(false);
  useEffect(() => {
    setLogo(cache.get(key)); setFailed(false);
    if (!enabled || cache.has(key)) return;
    const controller = new AbortController();
    axios.get(`https://api.themoviedb.org/3/${key}/images`, { params: { api_key: Api_key, include_image_language: 'en,null' }, signal: controller.signal, timeout: 10000 })
      .then(({ data }) => {
        const logos = data.logos || [];
        const path = (logos.find(image => image.iso_639_1 === 'en') || logos.find(image => !image.iso_639_1))?.file_path || null;
        if (!controller.signal.aborted) { cache.set(key, path); setLogo(path); }
      }).catch(() => {});
    return () => controller.abort();
  }, [key, enabled]);
  return <h1 className="hero-title-logo">{logo && !failed ? <img src={`https://image.tmdb.org/t/p/w500${logo}`} alt={title} onError={() => setFailed(true)} /> : title}</h1>;
}
